import { Action, createReducer, on } from '@ngrx/store';
import { BypassChain, BypassListReducer, BypassRule } from '../bypass-list.model';
import * as bypassListActions from './bypass-list.action';

const initialState: BypassListReducer = {
  input_bypass_list: [],
  output_bypass_list: [],
  forward_bypass_list: [],
  isLocallyChanged: false,
};

const CHAIN_STATE_KEY: Record<
  BypassChain,
  'input_bypass_list' | 'output_bypass_list' | 'forward_bypass_list'
> = {
  input: 'input_bypass_list',
  output: 'output_bypass_list',
  forward: 'forward_bypass_list',
};

function getChainRules(state: BypassListReducer, chain: BypassChain): BypassRule[] {
  return state[CHAIN_STATE_KEY[chain]];
}

function updateChain(
  state: BypassListReducer,
  chain: BypassChain,
  rules: BypassRule[]
): BypassListReducer {
  return {
    ...state,
    [CHAIN_STATE_KEY[chain]]: rules,
    isLocallyChanged: true,
  };
}

const reducer = createReducer(
  initialState,

  on(bypassListActions.setBypassList, (state, props) => ({
    ...state,
    input_bypass_list: props.bypassList.input_bypass_list,
    output_bypass_list: props.bypassList.output_bypass_list,
    forward_bypass_list: props.bypassList.forward_bypass_list,
    isLocallyChanged: false,
  })),

  on(bypassListActions.addBypassRule, (state, props) =>
    updateChain(state, props.chain, [...getChainRules(state, props.chain), props.bypassRule])
  ),

  on(bypassListActions.updateBypassRule, (state, props) =>
    updateChain(
      state,
      props.chain,
      getChainRules(state, props.chain).map((rule) =>
        rule.id === props.bypassRule.id ? { ...props.bypassRule } : rule
      )
    )
  ),

  on(bypassListActions.deleteBypassRules, (state, props) =>
    updateChain(
      state,
      props.chain,
      getChainRules(state, props.chain).filter((rule) => !props.ids.includes(rule.id))
    )
  ),

  on(bypassListActions.reorderBypassRules, (state, props) =>
    updateChain(state, props.chain, props.rules)
  ),

  on(bypassListActions.setBypassListSaved, (state) => ({
    ...state,
    isLocallyChanged: false,
  })),

  on(bypassListActions.clearBypassList, () => ({
    ...initialState,
  }))
);

export function bypassListReducer(state: BypassListReducer | undefined, action: Action) {
  return reducer(state, action);
}
